export default __webpack_public_path__ + "fonts/761c500cf39d357bdf961d53b068db49.svg";